import { render, staticRenderFns } from "./BarcodeRecognition.vue?vue&type=template&id=e14b85c8&scoped=true&"
import script from "./BarcodeRecognition.vue?vue&type=script&lang=js&"
export * from "./BarcodeRecognition.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeRecognition.vue?vue&type=style&index=0&id=e14b85c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14b85c8",
  null
  
)

export default component.exports